// extracted by mini-css-extract-plugin
module.exports = {"root":"abm-link-preview_root__y_4l_","image":"abm-link-preview_image__zoVZ8","header":"abm-link-preview_header__xmkyO"};